import { restClient } from '../config/restClient'

export const getStaticDeclineReasons = async () => {
  const response = await restClient('/api/company/static/decline_reasons', {
    method: 'GET',
  })

  return response.data
}
